import React, { ReactNode } from 'react';
import styles from './assets/adminWork-screen.module.scss';
import classNames from 'classnames';
import AdminWorksGrid from './components/AdminWorksGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';

import RoleLayout from 'src/components/layout/RoleLayout';
import { IAdminWork } from 'src/types/adminWork';

import CreateAdminWorkButton from './components/CreateAdminWorkButton';
import Loader from '../../../../../../components/Loader';
import user from '../../../../../../services/user-auth';
import UserRole from '../../../../../../enumerables/user-role';

export interface StateProps {
    data: Paginated<IAdminWork>;
    inProgress: boolean;
    providers: SelectObject[];
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
}

export interface OwnProps {}
export interface OwnState {
    dataToCsV: string[][];
}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class AdminWorksList extends React.Component<Props, OwnState> {
    constructor(props: Props) {
        super(props);
        this.state = {
            dataToCsV: [
                [
                    'Date',
                    'Provider',
                    'Start Time',
                    'End Time',
                    'Total Hours',
                    'Admin Rate per Hour',
                    'Total',
                    'Comment',
                    'Status',
                ],
            ],
        };
    }
    componentDidMount() {
        this.props.getProviders({});
    }
    public render(): ReactNode {
        const { data, getData, providers, inProgress } = this.props;

        const isProvider = user.getRoles().includes(UserRole.ROLE_USER);
        const isSupervisor = user.getSupervisor();
        return (
            <RoleLayout>
                {isProvider && !isSupervisor ? null : <div className={'isGetCsv'}></div>}
                <div className={classNames(styles.pageHeading, 'pageHeading')}>
                    <h2 className={classNames(styles.pageHeadingTitle, 'pageHeadingTitle')}>
                        ADMIN WORKS {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>

                    <CreateAdminWorkButton />
                </div>
                {inProgress ? <Loader /> : null}
                <div className={classNames(styles.list)}>
                    <AdminWorksGrid
                        providers={providers}
                        getDataCsv={this.props.getDataCsv}
                        data={data}
                        getData={getData}
                    />
                </div>
            </RoleLayout>
        );
    }
}

export default AdminWorksList;
